// extracted by mini-css-extract-plugin
module.exports = {"accordions":"accordions__rs1nt"};